import { Box, Grid } from '@mui/material';
import React from 'react';
function ListAndView({ left, view, leftWidth = 334, resizable = false, minLeftWidth = 180, maxLeftWidth }) {
    const [width, setWidth] = React.useState(leftWidth);
    const dragRef = React.useRef(null);
    const startResize = (e) => {
        e.preventDefault();
        dragRef.current = { startX: e.clientX, startWidth: width };
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
    };
    React.useEffect(() => {
        if (!resizable)
            return;
        const onMove = (e) => {
            if (!dragRef.current)
                return;
            const delta = e.clientX - dragRef.current.startX;
            const newWidth = dragRef.current.startWidth + delta;
            const max = maxLeftWidth !== null && maxLeftWidth !== void 0 ? maxLeftWidth : Math.round(window.innerWidth * 0.5);
            setWidth(Math.min(max, Math.max(minLeftWidth, newWidth)));
        };
        const onUp = () => {
            dragRef.current = null;
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
        return () => {
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
        };
    }, [resizable, minLeftWidth, maxLeftWidth]);
    const effectiveWidth = resizable ? width : leftWidth;
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, spacing: 0, sx: {
                marginTop: '0px !important',
                height: '100%',
                minHeight: 0,
                minWidth: 0,
                width: '100%',
                maxWidth: '100%',
                flexWrap: 'nowrap',
                overflow: 'hidden',
            } },
            React.createElement(Grid, { item: true, xs: "auto", sx: { height: '100%', position: 'relative', flexShrink: 0 } },
                React.createElement(Box, { sx: {
                        width: `${effectiveWidth}px`,
                        minWidth: `${effectiveWidth}px`,
                        maxWidth: `${effectiveWidth}px`,
                        height: '100%',
                        overflow: 'hidden'
                    } }, left),
                resizable && (React.createElement(Box, { onMouseDown: startResize, sx: {
                        position: 'absolute', right: '-3px', top: 0, bottom: 0, width: '6px',
                        cursor: 'col-resize', zIndex: 1,
                        backgroundColor: 'transparent',
                        transition: 'background-color 0.15s',
                        '&:hover': { backgroundColor: 'rgba(18, 113, 71, 0.35)' }
                    } }))),
            React.createElement(Grid, { item: true, xs: true, sx: { height: '100%', minWidth: 0, minHeight: 0, width: 0, maxWidth: 'none', flex: '1 1 0', overflow: 'hidden' } },
                React.createElement(Box, { sx: { height: '100%', minHeight: 0, minWidth: 0, width: '100%', maxWidth: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' } }, view)))));
}
export default ListAndView;
